import React, { Component } from 'react';
import { reaction } from 'mobx';
import { disposeOnUnmount } from 'mobx-react';
import Slide from './slide/index';
import { RenderPostionType } from '@src/js/constant';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';

export interface IDomCompatibleWrapperProps {
    width: number;
    height: number;
    left: number;
    top: number;
    scale: number;
    wrapLeft: number;
    wrapTop: number;
    horizontalOffest: number
    getPageScale: () => number;
    mobileEditMode?: () => any;
}

export interface IDomCompatibleWrapperStates {
    slideList: Record<string, any>[];
}

export default class DomCompatibleWrapper extends Component<IDomCompatibleWrapperProps, IDomCompatibleWrapperStates> {
    public state = {
        slideList: this.getAppServices().viewableServiceLayer.selectionService.slides,
    };

    public slideRef = {};

    public componentDidMount(): void {
        disposeOnUnmount(this, reaction(() => ({
            slideList: this.getAppServices().viewableServiceLayer.selectionService.slides,
        }), (obj) => {
            this.setState({
                slideList: obj.slideList,
            });
        }));

        disposeOnUnmount(
            this,
            reaction(
                () => this.getAppServices().viewableServiceLayer.selectionService.currentSlide,
                () => {
                    this.forceUpdate();
                },
            ),
        );
    }

    public render(): JSX.Element {
        const {
            width,
            height,
            left,
            top,
            scale,
        } = this.props;

        const { slideWidth, slideHeight } = this.getAppServices().getUiDataService().presentation.props;
        const { currentSlideIndex, currentSlide } = this.getAppServices().viewableServiceLayer.selectionService;
        if (!currentSlide) {
            return <></>;
        }
        return (
            <div
                style={{
                    width: Math.round(width / scale),
                    height: Math.round(height / scale),
                    transformOrigin: 'left top',
                    transform: `scale(${scale})`,
                    position: 'absolute',
                    pointerEvents: 'none',
                }}
            >
                <div
                    id="slide"
                    style={{
                        position: 'absolute',
                        width: slideWidth,
                        height: slideHeight,
                        top: Math.round(top / scale),
                        left: Math.round(left / scale),
                    }}
                >
                    <Slide
                        key={`slide-${currentSlide.key}`}
                        ref={(slideRef) => {
                            this.slideRef[currentSlide.key] = slideRef;
                        }}
                        scale={scale}
                        getPageScale={this.props.getPageScale}
                        slideModel={currentSlide}
                        slideWidth={slideWidth}
                        slideHeight={slideHeight}
                        isShown={true}
                        region={RenderPostionType.CANVAS}
                        mobileEditMode={this.props.mobileEditMode}
                        index={currentSlideIndex}
                    />
                </div>
            </div>
        );
    }

    private getAppServices(): IEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IEditorAppServices;
    }
}
